import { Tag } from "@brg/api/dist/api-core/types";
import { useState } from "react";
import { useAPIMethodArray } from "./useAPIMethodArray";
import { CompetitionAPI } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useDeepCompareEffect } from "shared/utils/useDeepCompareEffect";

const useCompetitionTagList = ({ filter }: any) => {
    const { i18n: { language } } = useTranslation();
    const [time, setTime] = useState(Date.now());

    const [data, loading] = useAPIMethodArray<Tag[], any>(CompetitionAPI.GetCompetitionTagList, filter, language, time, false, true);

    useDeepCompareEffect(() => {
        if (!loading) {
            setTime(Date.now());
        }
    }, [filter])

    return { tags: data, loading };
}

export default useCompetitionTagList;import { Tag } from "@brg/api/dist/api-core/types";
import { useState } from "react";
import { useAPIMethodArray } from "./useAPIMethodArray";
import { CompetitionAPI } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useDeepCompareEffect } from "shared/utils/useDeepCompareEffect";

const useCompetitionTagList = ({ filter }: any) => {
    const { i18n: { language } } = useTranslation();
    const [time, setTime] = useState(Date.now());

    const [data, loading] = useAPIMethodArray<Tag[], any>(CompetitionAPI.GetCompetitionTagList, filter, language, time, false, true);

    useDeepCompareEffect(() => {
        if (!loading) {
            setTime(Date.now());
        }
    }, [filter])

    return { tags: data, loading };
}

export default useCompetitionTagList;